import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import Status               from "dashboard/dist/Core/Status";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import EditDialog           from "dashboard/dist/Components/EditDialog";
import Columns              from "dashboard/dist/Components/Columns";
import InputField           from "dashboard/dist/Components/InputField";

// Actions
import {
    fetchMaterialEdit, fetchMaterialCreate, editMaterial,
} from "Actions/Admin/Strech/MaterialActions";



/**
 * The Strech Material Edit Dialog
 */
class MaterialEdit extends React.Component {
    // The Initial Data
    initialData = {
        strechMaterialID  : 0,
        strechID          : 0,
        strechClassID     : 0,
        programMaterialID : 0,
        materialID        : 0,
        position          : 0,
        status            : Status.getID("ACTIVE"),
    }

    // The Current State
    state = {
        loading : false,
        data    : { ...this.initialData },
        errors  : {},
    }



    /**
     * Get the Data when the Element ID changes
     * @param {Object} prevProps
     * @returns {Void}
     */
    componentDidUpdate(prevProps) {
        const { open, edition, elemID, elem, strechID, position, fetchMaterialEdit, fetchMaterialCreate } = this.props;
        let loading = false;
        let data    = null;

        // Dialog Opens
        if (open && !prevProps.open) {
            data = { ...this.initialData };
            // Load new data
            if (elemID) {
                fetchMaterialEdit(elemID);
                loading = true;
            // Load edit data
            } else if (strechID) {
                fetchMaterialCreate(strechID);
                loading = true;
            }

        // Data Updated
        } else if (prevProps.edition !== edition) {
            if (elemID) {
                data = Utils.extend(this.initialData, elem);
            } else {
                data = { ...this.initialData, strechID, position };
            }
        }

        // Set the State
        if (data) {
            this.setState({ data, loading, errors : {} });
        }
    }

    /**
     * Handles the Input Change
     * @param {String} name
     * @param {*}      value
     * @returns {Void}
     */
    handleChange = (name, value) => {
        this.setState({
            data   : { ...this.state.data,   [name] : value },
            errors : { ...this.state.errors, [name] : ""    },
        });
    }

    /**
     * Handles the Submit
     * @returns {Promise}
     */
    handleSubmit = async () => {
        const { data, loading } = this.state;
        if (!loading) {
            this.setState({ loading : true, errors : {} });
            try {
                await this.props.editMaterial(data);
                this.setState({ loading : false });
                this.props.onSubmit();
            } catch (errors) {
                this.setState({ loading : false, errors });
            }
        }
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { elemID, open, onClose, materials, classes } = this.props;
        const { data, loading, errors                     } = this.state;

        return <EditDialog
            open={open}
            icon="material"
            title={!!elemID ? "MATERIALS_EDIT_TITLE" : "MATERIALS_ASSIGN_TITLE"}
            error={errors.form}
            onSubmit={this.handleSubmit}
            onClose={onClose}
            isLoading={loading}
        >
            <InputField
                type="select"
                name="materialID"
                label="MATERIALS_SINGULAR"
                value={data.materialID}
                error={errors.materialID}
                onChange={this.handleChange}
                options={materials}
                withNone
                isRequired
                shrinkLabel
            />
            <InputField
                type="select"
                name="strechClassID"
                label="MATERIALS_CLASS"
                value={data.strechClassID}
                error={errors.strechClassID}
                onChange={this.handleChange}
                options={classes}
                customText="MATERIALS_WELCOME"
                withNone
                withCustom
                customFirst
                isRequired
            />
            <Columns>
                <InputField
                    type="number"
                    name="position"
                    label="GENERAL_POSITION"
                    value={data.position}
                    error={errors.position}
                    onChange={this.handleChange}
                    shrinkLabel
                />
                <InputField
                    type="select"
                    name="status"
                    label="GENERAL_STATUS"
                    value={data.status}
                    error={errors.status}
                    onChange={this.handleChange}
                    options={Status.getSelect()}
                    withNone
                    isRequired
                    shrinkLabel
                />
            </Columns>
        </EditDialog>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchMaterialEdit   : PropTypes.func.isRequired,
        fetchMaterialCreate : PropTypes.func.isRequired,
        editMaterial        : PropTypes.func.isRequired,
        open                : PropTypes.bool.isRequired,
        onClose             : PropTypes.func.isRequired,
        onSubmit            : PropTypes.func.isRequired,
        edition             : PropTypes.number.isRequired,
        position            : PropTypes.number.isRequired,
        materials           : PropTypes.array.isRequired,
        classes             : PropTypes.array.isRequired,
        elem                : PropTypes.object.isRequired,
        elemID              : PropTypes.number,
        strechID            : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            edition   : state.strechMaterial.edition,
            position  : state.strechMaterial.position,
            materials : state.strechMaterial.materials,
            classes   : state.strechMaterial.classes,
            elem      : state.strechMaterial.elem,
        };
    }
}

export default connect(MaterialEdit.mapStateToProps, {
    fetchMaterialEdit, fetchMaterialCreate, editMaterial,
})(MaterialEdit);
